// Glass dropdowns in the collection bar (sections/main-collection-product-
// grid.liquid; styles: "Collection bar: glass dropdowns" in
// assets/custom-styles.css).
//
// - Desktop (a device that can hover): hovering a dropdown expands it
//   (pure CSS); mouse clicks on its heading don't toggle it, so it never
//   stays stuck open after the pointer leaves.
// - Touch screens, and keyboard use anywhere: the heading (the current
//   collection / the selected PRODUCTS or ATHLETES option) toggles
//   .is-open.
// - Choosing an option, tapping outside, or Escape closes it.
// The PRODUCTS / ATHLETES options themselves are switched by
// assets/collection-image-toggle.js; this runs first (capture phase) and
// only opens / closes the box.
(function () {
  if (window.__p3GlassDropdown) return;
  window.__p3GlassDropdown = true;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function setOpen(dd, open) {
    dd.classList.toggle('is-open', open);
    var toggle = dd.querySelector('.p3-glass-dd__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }

  function closeAll(except) {
    document.querySelectorAll('[data-glass-dd].is-open').forEach(function (dd) {
      if (dd !== except) setOpen(dd, false);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var dd = event.target.closest('[data-glass-dd]');
      if (!dd) {
        closeAll();
        return;
      }

      var heading =
        event.target.closest('.p3-glass-dd__toggle') ||
        event.target.closest('.p3-glass-switch .collection-image-toggle__option.is-active');

      if (heading) {
        // mouse click on a hover device: hover already shows the list
        if (canHover.matches && event.detail > 0) return;
        closeAll(dd);
        setOpen(dd, !dd.classList.contains('is-open'));
        return;
      }

      // an option (collection link, or the other PRODUCTS / ATHLETES
      // option): let it do its thing, then close
      if (event.target.closest('.p3-glass-dd__option, .collection-image-toggle__option')) {
        setTimeout(function () {
          setOpen(dd, false);
        }, 0);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  // Bottom of the top menu bar, for the collection pages' full-screen
  // glass layer ("Collection pages: dropdowns as plain text" in
  // assets/custom-styles.css).
  function setHeaderBottom() {
    var header = document.querySelector('.section-header');
    var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--p3-header-bottom', bottom + 'px');
  }
  setHeaderBottom();
  window.addEventListener('scroll', setHeaderBottom, { passive: true });
  window.addEventListener('resize', setHeaderBottom);
  window.addEventListener('load', setHeaderBottom);
  document.addEventListener('pointerover', function (event) {
    if (event.target.closest && event.target.closest('[data-glass-dd]')) setHeaderBottom();
  });
})();
